// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selected-replica-box[data-v-81175eb4] {\n  border-radius: 1.25rem;\n  border: 1px solid;\n  min-width: 6rem;\n  padding: 7px;\n  color: #0e6488;\n  width: auto;\n  height: 2.5rem;\n  font-weight: 500;\n}\n.selection-title[data-v-81175eb4] {\n  color: #6c7c7b;\n}\n.text-caption[data-v-81175eb4] {\n  white-space: nowrap;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
